import { render, staticRenderFns } from "./StoriesPreview.vue?vue&type=template&id=5f819f45&"
import script from "./StoriesPreview.vue?vue&type=script&lang=js&"
export * from "./StoriesPreview.vue?vue&type=script&lang=js&"
import style0 from "./StoriesPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports